<p-dialog
  [visible]="visible"
  (onHide)="hide()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px' }"
  styleClass="edit-start-date-dialog"
  header="Editar fecha de inicio de la tabla">

  <form [formGroup]="form" class="edit-start-date-form">
    <!-- Advertencia de cascada -->
    <div class="warn-box">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        Al cambiar esta fecha se recalcularán en cascada las fechas de
        <strong>{{ periodsCount }}</strong> período(s) preservando la cadencia mensual.
        Solo se modifican fechas de la tabla: ni los montos ni las fechas de inicio y fin
        del arrendamiento se tocan. El cambio queda registrado en la auditoría del arrendamiento.
      </span>
    </div>

    <!-- Fecha de inicio -->
    <div class="field">
      <!--
        Dice "primera letra de la tabla", no "período 1": en los arrendamientos migrados con rentas
        parciales la letra numerada 1 NO es la primera de la tabla, y nombrarla así hacía que el
        operador tecleara contra una fecha distinta de la que anclaba el recorrido (B-011).
      -->
      <label for="startDate">Nueva fecha de la primera letra de la tabla</label>
      <p-calendar
        inputId="startDate"
        formControlName="startDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        [readonlyInput]="true"
        appendTo="body"
        styleClass="w-full"
        [style]="{ width: '100%' }">
      </p-calendar>
      <small class="p-error" *ngIf="form.get('startDate')?.invalid && form.get('startDate')?.touched">
        La fecha de inicio es obligatoria.
      </small>
    </div>

    <!-- Motivo (obligatorio) -->
    <div class="field">
      <label for="reason">Motivo del cambio</label>
      <textarea
        id="reason"
        pInputTextarea
        formControlName="reason"
        rows="3"
        [maxlength]="500"
        placeholder="Describe por qué se corrige la fecha de inicio (queda en auditoría)">
      </textarea>
      <small class="p-error" *ngIf="form.get('reason')?.invalid && form.get('reason')?.touched">
        El motivo es obligatorio.
      </small>
    </div>

    <!-- Confirmación extra cuando hay períodos pagados/atrasados -->
    <div class="paid-warn" *ngIf="paidPeriodsCount > 0">
      <div class="paid-warn-head">
        <i class="pi pi-exclamation-circle"></i>
        <span><strong>{{ paidPeriodsCount }}</strong> período(s) ya PAGADO(S) o ATRASADO(S) también serán recorridos.</span>
      </div>
      <div class="field-checkbox">
        <p-checkbox formControlName="confirmPaidPeriods" [binary]="true" inputId="confirmPaid"></p-checkbox>
        <label for="confirmPaid">Confirmo que deseo recorrer las fechas aún con períodos ya pagados/atrasados.</label>
      </div>
      <small class="p-error" *ngIf="form.get('confirmPaidPeriods')?.invalid && form.get('confirmPaidPeriods')?.touched">
        Debes confirmar para continuar.
      </small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="hide()" [disabled]="loading"></button>
    <button pButton type="button" label="Guardar" icon="pi pi-check" (click)="save()" [disabled]="loading || form.invalid" [loading]="loading"></button>
  </ng-template>
</p-dialog>
